import axios from 'axios';
import * as endpoints from './const';

class YellowfinApi {
  static GetYellowfinSSO(ssoParam) {
    return axios
      .post(`${endpoints.YELLOWFIN_SSO}`, ssoParam)
      .then(response => response.data)
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }
}

export default YellowfinApi;



// WEBPACK FOOTER //
// ./src/api/YellowfinApi.js